import { useLocation, useNavigate } from 'react-router';

export function useProductTab() {
  const location = useLocation();
  const navigate = useNavigate();
  const hash = location.hash.slice(1);
  const tab = hash === 'offers' || hash === 'photos' || hash === 'properties' ? hash : 'main';
  const setTab = (value: string): void => {
    navigate({ pathname: location.pathname, search: location.search, hash: value === 'main' ? '' : `#${value}` }, { replace: true, state: location.state });
  };
  return { tab, setTab };
}
